module.exports = __webpack_public_path__ + "img/privacy-right.75a65d11.svg";